// NOT: docs/assets/mqle-load-more.js.md — gerekceler ve KONTRATLAR orada. Degistirmeden once oku.
class MqleLoadMore extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-load-more]');
    this.counter = this.querySelector('[data-load-more-count]');
    this.grid = document.getElementById('product-grid');
    if (!this.button || !this.grid) return;

    // FAIL-OPEN (27 Agu 2026): sonraki sayfa cozulemezse HICBIR SEY gizlenmez.
    // `is-active` yokken CSS butonu gizli tutar ve Dawn sayfalamasi gorunur kalir.
    // Boylece JS kapaliyken, hata alindiginda ya da baglanti cozulemediginde
    // musteri urunlere yine de ulasir. Onceki surumde buton kosulsuz gorunuyor,
    // sayfalama kosulsuz gizleniyordu; baglanti cozulemeyince tiklama sessizce
    // hicbir sey yapmiyordu ve son sayfadaki urunler ERISILEMEZ oluyordu.
    if (!this.nextUrl) return;

    this.classList.add('is-active');
    this.button.addEventListener('click', this.load.bind(this));
  }

  // Sonraki sayfa baglantisi.
  //
  // SINIF ADINA GUVENILMEZ: snippets/pagination.liquid icinde prev/next sinif
  // adlari ters yazilmis — `paginate.previous` baglantisi `pagination__item--next`,
  // `paginate.next` baglantisi `pagination__item--prev` sinifini aliyor
  // (satir 24 ve 66). Eski kod `.pagination__item--next` ariyordu; 1. sayfada
  // onceki sayfa olmadigi icin o element HIC yoktu.
  // Olculdu 27 Agu 2026, /collections/tum-makyaj-urunleri (18 urun):
  // tiklamada 0 ag istegi, 0 yeni kart, sayac "16 / 18"de takili kaldi.
  //
  // Cozum: baglanti SAYFA NUMARASINDAN cozulur. Filtre ve siralama
  // parametreleri href'te zaten tasindigi icin faceted gezinme de korunur.
  get nextUrl() {
    const wrapper = document.querySelector('.pagination-wrapper');
    if (!wrapper) return null;

    const current = parseInt(wrapper.dataset.page, 10) || 1;

    for (const link of wrapper.querySelectorAll('.pagination__list a[href]')) {
      const href = link.getAttribute('href');
      if (!href) continue;

      let page;
      try {
        page = parseInt(new URL(href, window.location.href).searchParams.get('page'), 10);
      } catch (error) {
        continue;
      }

      if (page === current + 1) return href;
    }

    return null;
  }

  // Hata halinde geri don: buton kapanir, sayfalama yeniden gorunur olur.
  bail() {
    this.button.hidden = true;
    this.classList.remove('is-active');
  }

  async load() {
    const url = this.nextUrl;
    if (!url || this.button.hasAttribute('aria-busy')) return;
    this.button.setAttribute('aria-busy', 'true');

    const oncekiSayi = this.grid.querySelectorAll(':scope > li').length;

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(response.status);
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');

      const gelen = doc.querySelectorAll('#product-grid > li');
      if (gelen.length === 0) throw new Error('bos sayfa');
      gelen.forEach((item) => this.grid.appendChild(item));

      // `data-page` ilerlesin ki bir sonraki tiklama dogru sayfayi bulsun.
      const pagination = document.querySelector('.pagination-wrapper');
      const nextPagination = doc.querySelector('.pagination-wrapper');
      if (pagination && nextPagination) pagination.replaceWith(nextPagination);
      else if (pagination) pagination.remove();

      const yeniSayi = this.grid.querySelectorAll(':scope > li').length;

      if (this.counter) {
        this.counter.textContent = this.counter.dataset.template
          .replace('[shown]', yeniSayi)
          .replace('[total]', this.dataset.total);
      }

      // Ekran okuyucu ve klavye: odak ilk yeni karta gecsin.
      // tabindex="-1" odagi programatik olarak alabilmek icin gerekli, ama
      // KALICI birakilirsa o baglanti sekme sirasindan cikar. Odak ayrilinca
      // geri alinir (tek seferlik dinleyici).
      const ilkYeni = this.grid.querySelectorAll(':scope > li')[oncekiSayi];
      const odak = ilkYeni && ilkYeni.querySelector('a[href]');
      if (odak) {
        odak.setAttribute('tabindex', '-1');
        odak.addEventListener(
          'blur',
          () => odak.removeAttribute('tabindex'),
          { once: true }
        );
        odak.focus({ preventScroll: true });
      }

      if (!this.nextUrl) this.button.hidden = true;
    } catch (error) {
      this.bail();
      console.error(error);
    } finally {
      this.button.removeAttribute('aria-busy');
    }
  }
}

customElements.define('mqle-load-more', MqleLoadMore);
